import React, { Component } from "react";
import { languages } from "../../constants/languages";
import ShuffleIcon from "@material-ui/icons/Shuffle";
import IconButton from "@material-ui/core/IconButton";
import { Tooltip, Checkbox, FormControlLabel } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
// import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

class DivideTeamsContainer extends Component {
  state = {
    open: false,
    onlyPresent: false,
    overwrite: false,
    sort: "random",
  };

  handleSortChange = (e) => {
    this.setState({ sort: e.target.value });
  };

  toggleDialog = () => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else if (this.props.teams.length > this.props.maxTeams) {
      this.props.toggleUpgradeDialog();
    } else {
      this.setState({ open: !this.state.open });
    }
  };

  handleCheck = (e) => {
    this.setState({
      onlyPresent: !this.state.onlyPresent,
    });
  };

  handleOverwriteCheck = (e) => {
    this.setState({
      overwrite: !this.state.overwrite,
    });
  };

  shuffle = (a) => {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.toggleDialog();
    const db = window.firebase.firestore();

    let batch = db.batch();
    let numWrites = 0;

    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    const teamsRef = tournamentRef.collection("teams");
    const poulesRef = tournamentRef.collection("poules");

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("teamsContactInfo")
      .get()
      .then((querySnapshot) => {
        var info = {};
        querySnapshot.forEach(function (doc) {
          info[doc.id] = doc.data();
        });
        let teams = this.props.teams;
        let teamsPresent = this.props.teams.filter((t) => t.present);
        if (this.state.onlyPresent && teamsPresent.length > 0) {
          teams = teamsPresent;
        }
        if (!this.state.overwrite) {
          teams = teams.filter((t) => !t.poule0);
        }

        // sort teams
        if (this.state.sort === "random") {
          teams = this.shuffle(teams.slice());
        } else {
          let sortKey = this.state.sort.slice(8);
          let sortType = "question";
          if (this.state.sort.includes("infoField")) {
            sortKey = this.state.sort.slice(9);
            sortType = "infoField";
          }
          teams.sort((a, b) => {
            let criteriumA = "";
            let criteriumB = "";
            if (sortType === "question") {
              criteriumA = ((info[a.id] || {}).questions || {})[sortKey] || "";
              criteriumB = ((info[b.id] || {}).questions || {})[sortKey] || "";
            } else {
              criteriumA = (info[a.id] || {})[sortKey] || "";
              criteriumB = (info[b.id] || {})[sortKey] || "";
            }

            function chunkify(t) {
              var tz = [],
                x = 0,
                y = -1,
                n = 0,
                i,
                j;

              while ((i = (j = t.charAt(x++)).charCodeAt(0))) {
                // eslint-disable-next-line
                var m = i == 46 || (i >= 48 && i <= 57);
                if (m !== n) {
                  tz[++y] = "";
                  n = m;
                }
                tz[y] += j;
              }
              return tz;
            }

            var aa = chunkify(criteriumA.toLowerCase());
            var bb = chunkify(criteriumB.toLowerCase());

            for (let x = 0; aa[x] && bb[x]; x++) {
              if (aa[x] !== bb[x]) {
                var c = Number(aa[x]),
                  d = Number(bb[x]);
                // eslint-disable-next-line
                if (c == aa[x] && d == bb[x]) {
                  return c - d;
                } else return aa[x] > bb[x] ? 1 : -1;
              }
            }
            return aa.length - bb.length;
          });
          teams.reverse();
        }

        let bracketSpots = 0;
        let emptySpotsSeededDraw = 0;
        // reset everything first
        if (this.state.overwrite) {
          // reset byes in subBrackets
          this.props.allBracketsForPhase
            .filter((b) => b.subBracketTo)
            .forEach((b) => {
              const poules = this.props.poules.filter(
                (p) => p.bracket === b.id
              );
              poules.forEach((p) => {
                let pouleRef = poulesRef.doc(p.id);
                let toUpdate = {};
                toUpdate["status0"] = null;
                toUpdate["status1"] = null;
                batch.update(pouleRef, toUpdate);
                if (numWrites > 450) {
                  batch.commit();
                  batch = db.batch();
                  numWrites = 0;
                } else {
                  numWrites++;
                }
              });
            });
        }
        let structureObjectsSorted = [];
        this.props.structureObjects.forEach((o) => {
          if (o.size) {
            let poules = this.props.poules.filter((p) => p.bracket === o.id);

            if (this.state.overwrite) {
              bracketSpots += Number(o.size);
              // console.log(poules, poulesNextRound);
              poules.forEach((p, i) => {
                batch.update(poulesRef.doc(p.id), {
                  status0: null,
                  status1: null,
                });
                if (numWrites > 450) {
                  batch.commit();
                  batch = db.batch();
                  numWrites = 0;
                } else {
                  numWrites++;
                }

                let pouleKeyName =
                  p.bracketRound === o.size
                    ? p.fase
                    : p.fase + "-" + p.bracketRound + "-" + p.bracket;
                let team1 = this.props.teams.find(
                  (t) =>
                    t["poule" + pouleKeyName] === p.id &&
                    t["numInPoule" + pouleKeyName] === 0
                );
                if (team1) {
                  let toUpdate = {};
                  toUpdate["poule" + pouleKeyName] = null;
                  batch.update(teamsRef.doc(team1.id), toUpdate);
                  if (numWrites > 450) {
                    batch.commit();
                    batch = db.batch();
                    numWrites = 0;
                  } else {
                    numWrites++;
                  }
                }
                let team2 = this.props.teams.find(
                  (t) =>
                    t["poule" + pouleKeyName] === p.id &&
                    t["numInPoule" + pouleKeyName] === 1
                );
                if (team2) {
                  let toUpdate = {};
                  toUpdate["poule" + pouleKeyName] = null;
                  batch.update(teamsRef.doc(team2.id), toUpdate);
                  if (numWrites > 450) {
                    batch.commit();
                    batch = db.batch();
                    numWrites = 0;
                  } else {
                    numWrites++;
                  }
                }
              });
            } else {
              poules
                .filter((p) => p.bracketRound === o.size)
                .forEach((p) => {
                  let emptySpotsBracketMatch = 0;
                  const team1 = this.props.teams.find(
                    (t) => t["poule0"] === p.id && t["numInPoule0"] === 0
                  );
                  const team2 = this.props.teams.find(
                    (t) => t["poule0"] === p.id && t["numInPoule0"] === 1
                  );
                  if (!team1 && p.status0 !== "bye") {
                    emptySpotsBracketMatch++;
                  }
                  if (!team2 && p.status1 !== "bye") {
                    emptySpotsBracketMatch++;
                  }
                  emptySpotsSeededDraw += emptySpotsBracketMatch;

                  let spotsBracketMatch = 0;
                  if (!team1 && !team2) {
                    spotsBracketMatch += 2;
                  } else if (
                    (p.status0 === "bye" && p.status1 !== "bye" && !team2) ||
                    (p.status1 === "bye" && p.status0 !== "bye" && !team1)
                  ) {
                    spotsBracketMatch += 2;
                  }
                  bracketSpots += spotsBracketMatch;
                });
            }
            structureObjectsSorted.unshift(o);
          } else if (o.pouleSize) {
            if (this.state.overwrite) {
              let pouleSize = o.pouleSize;
              let toUpdatePoule = {};
              for (let i = 0; i < Number(pouleSize); i++) {
                toUpdatePoule["status" + i] = null;

                let team1 = this.props.teams.find(
                  (t) => t["poule0"] === o.id && t["numInPoule0"] === i
                );
                if (team1) {
                  let toUpdate = {};
                  toUpdate["poule0"] = null;
                  batch.update(teamsRef.doc(team1.id), toUpdate);
                  if (numWrites > 450) {
                    batch.commit();
                    batch = db.batch();
                    numWrites = 0;
                  } else {
                    numWrites++;
                  }
                }
              }
              batch.update(poulesRef.doc(o.id), toUpdatePoule);
              if (numWrites > 450) {
                batch.commit();
                batch = db.batch();
                numWrites = 0;
              } else {
                numWrites++;
              }
            }
            structureObjectsSorted.push(o);
          }
        });

        bracketSpots = bracketSpots / 2;
        let byesSetInSubBrackets = {};
        structureObjectsSorted.forEach((o) => {
          if (o.size) {
            let poules = this.props.poules.filter((p) => p.bracket === o.id);
            let numByes =
              bracketSpots * 2 - teams.length > 0
                ? bracketSpots * 2 - teams.length
                : 0;

            if (this.state.overwrite) {
              poules
                .filter((p) => p.bracketRound === o.size)
                .forEach((p, i) => {
                  let newTeam1 = teams.pop();
                  let toUpdate1 = {};

                  toUpdate1["poule0"] = p.id;
                  toUpdate1["numInPoule0"] = 0;

                  let newTeam2 =
                    numByes > 0
                      ? numByes + i < o.size / 2
                        ? Math.random() >= 0.5
                          ? "bye"
                          : teams.pop()
                        : "bye"
                      : teams.pop();
                  if (newTeam2 === "bye") {
                    numByes--;

                    // set bye
                    let toUpdate = {};
                    toUpdate["status1"] = "bye";
                    batch.update(poulesRef.doc(p.id), toUpdate);
                    if (numWrites > 450) {
                      batch.commit();
                      batch = db.batch();
                      numWrites = 0;
                    } else {
                      numWrites++;
                    }

                    // team1 to next round
                    let toPouleKeyName =
                      p.fase + "-" + p.bracketRound / 2 + "-" + p.bracket;
                    let resultSpot = this.props.resultSpotsAll.find(
                      (rs) =>
                        rs.fromPoule === p.id &&
                        rs.rank === 0 &&
                        rs.belongsToBracket === p.bracket
                    );
                    let toPoule = resultSpot["poule" + p.fase];
                    let toNumInPoule = resultSpot["numInPoule" + p.fase];

                    toUpdate1["poule" + toPouleKeyName] = toPoule;
                    toUpdate1["numInPoule" + toPouleKeyName] = toNumInPoule;

                    // check for subbracket and set bye in subbracket
                    let resultSpotLoser = this.props.resultSpotsAll.find(
                      (rs) =>
                        rs.fromPoule === p.id &&
                        rs.rank === 1 &&
                        rs.belongsToBracket === p.bracket
                    );
                    while (resultSpotLoser) {
                      let toPouleLoser = resultSpotLoser["poule" + p.fase];
                      let loserPouleSubBracket =
                        this.props.poulesByKey[toPouleLoser] || {};
                      let toNumInPouleLoser =
                        resultSpotLoser["numInPoule" + p.fase];
                      if (toPouleLoser) {
                        let pouleRefLoser = poulesRef.doc(toPouleLoser);
                        let toUpdateLoser = {};
                        toUpdateLoser["status" + toNumInPouleLoser] = newTeam2;
                        if (byesSetInSubBrackets[toPouleLoser] === undefined) {
                          byesSetInSubBrackets[toPouleLoser] = {};
                        }
                        byesSetInSubBrackets[toPouleLoser][
                          toNumInPouleLoser
                        ] = true;
                        batch.update(pouleRefLoser, toUpdateLoser);
                        if (numWrites > 450) {
                          batch.commit();
                          batch = db.batch();
                          numWrites = 0;
                        } else {
                          numWrites++;
                        }
                        if (
                          (byesSetInSubBrackets[toPouleLoser] || {})[
                            toNumInPouleLoser === 0 ? 1 : 0
                          ]
                        ) {
                          let resultSpotWinnerSubBracket =
                            this.props.resultSpotsAll.find(
                              (rs) =>
                                rs.fromPoule === toPouleLoser &&
                                rs.rank === 0 &&
                                rs.belongsToBracket ===
                                  loserPouleSubBracket.bracket
                            );
                          if (resultSpotWinnerSubBracket) {
                            if (resultSpotWinnerSubBracket["poule" + p.fase]) {
                              let pouleRefWinnerSubBracket = poulesRef.doc(
                                resultSpotWinnerSubBracket["poule" + p.fase]
                              );
                              let toUpdateWinnerSubBracket = {};
                              toUpdateWinnerSubBracket[
                                "status" +
                                  resultSpotWinnerSubBracket[
                                    "numInPoule" + p.fase
                                  ]
                              ] = newTeam2;
                              if (
                                byesSetInSubBrackets[
                                  resultSpotWinnerSubBracket["poule" + p.fase]
                                ] === undefined
                              ) {
                                byesSetInSubBrackets[
                                  resultSpotWinnerSubBracket["poule" + p.fase]
                                ] = {};
                              }
                              byesSetInSubBrackets[
                                resultSpotWinnerSubBracket["poule" + p.fase]
                              ][
                                resultSpotWinnerSubBracket[
                                  "numInPoule" + p.fase
                                ]
                              ] = true;
                              batch.update(
                                pouleRefWinnerSubBracket,
                                toUpdateWinnerSubBracket
                              );
                              if (numWrites > 450) {
                                batch.commit();
                                batch = db.batch();
                                numWrites = 0;
                              } else {
                                numWrites++;
                              }
                            }
                          }
                        }

                        resultSpotLoser = this.props.resultSpotsAll.find(
                          (rs) =>
                            rs.fromPoule === toPouleLoser &&
                            rs.rank === 1 &&
                            rs.belongsToBracket === loserPouleSubBracket.bracket
                        );
                      } else {
                        // break while loop
                        resultSpotLoser = undefined;
                      }
                    }
                  } else {
                    let toUpdate2 = {};
                    toUpdate2["poule0"] = p.id;
                    toUpdate2["numInPoule0"] = 1;

                    batch.update(teamsRef.doc(newTeam2.id), toUpdate2);
                    if (numWrites > 450) {
                      batch.commit();
                      batch = db.batch();
                      numWrites = 0;
                    } else {
                      numWrites++;
                    }
                  }
                  batch.update(teamsRef.doc(newTeam1.id), toUpdate1);
                  if (numWrites > 450) {
                    batch.commit();
                    batch = db.batch();
                    numWrites = 0;
                  } else {
                    numWrites++;
                  }
                  bracketSpots--;
                });
            } else {
              let numByesForSeededDraw = emptySpotsSeededDraw - teams.length;
              poules
                .filter((p) => p.bracketRound === o.size)
                .forEach((p, i) => {
                  let currentTeam1 =
                    (p.status0 === "bye" ? "bye" : null) ||
                    this.props.teams.find(
                      (t) => t["poule0"] === p.id && t["numInPoule0"] === 0
                    ) ||
                    null;
                  let currentTeam2 =
                    (p.status1 === "bye" ? "bye" : null) ||
                    this.props.teams.find(
                      (t) => t["poule0"] === p.id && t["numInPoule0"] === 1
                    ) ||
                    null;

                  let newTeam1 = null;
                  let newTeam2 = null;
                  if (!currentTeam1) {
                    if (currentTeam2 !== "bye" && numByesForSeededDraw > 0) {
                      newTeam1 = "bye";
                      numByesForSeededDraw--;
                    } else {
                      newTeam1 = "team";
                    }
                  }
                  if (!currentTeam2) {
                    if (
                      numByesForSeededDraw > 0 &&
                      newTeam1 !== "bye" &&
                      currentTeam1 !== "bye"
                    ) {
                      newTeam2 = "bye";
                      numByesForSeededDraw--;
                    } else {
                      newTeam2 = "team";
                    }
                  }

                  if (newTeam1) {
                    if (newTeam1 === "bye") {
                      // set bye
                      let toUpdate = {};
                      toUpdate["status0"] = "bye";
                      batch.update(poulesRef.doc(p.id), toUpdate);
                      if (numWrites > 450) {
                        batch.commit();
                        batch = db.batch();
                        numWrites = 0;
                      } else {
                        numWrites++;
                      }

                      if (currentTeam2) {
                        // team2 to next round
                        let toUpdateCurrentTeam2 = {};

                        let toPouleKeyName =
                          p.fase + "-" + p.bracketRound / 2 + "-" + p.bracket;
                        let resultSpot = this.props.resultSpotsAll.find(
                          (rs) =>
                            rs.fromPoule === p.id &&
                            rs.rank === 0 &&
                            rs.belongsToBracket === p.bracket
                        );
                        let toPoule = resultSpot["poule" + p.fase];
                        let toNumInPoule = resultSpot["numInPoule" + p.fase];

                        toUpdateCurrentTeam2["poule" + toPouleKeyName] =
                          toPoule;
                        toUpdateCurrentTeam2["numInPoule" + toPouleKeyName] =
                          toNumInPoule;
                        batch.update(
                          teamsRef.doc(currentTeam2.id),
                          toUpdateCurrentTeam2
                        );
                        if (numWrites > 450) {
                          batch.commit();
                          batch = db.batch();
                          numWrites = 0;
                        } else {
                          numWrites++;
                        }

                        // set byes in subbrackets
                        const setSubsResults = this.setByesInSubBrackets(
                          p,
                          batch,
                          numWrites
                        );
                        batch = setSubsResults[0];
                        numWrites = setSubsResults[1];
                      }
                    } else if (newTeam1 === "team") {
                      const newTeam = teams.pop();
                      let toUpdateNewTeam = {};

                      toUpdateNewTeam["poule0"] = p.id;
                      toUpdateNewTeam["numInPoule0"] = 0;
                      batch.update(teamsRef.doc(newTeam.id), toUpdateNewTeam);
                      if (numWrites > 450) {
                        batch.commit();
                        batch = db.batch();
                        numWrites = 0;
                      } else {
                        numWrites++;
                      }

                      if (currentTeam2 === "bye" || newTeam2 === "bye") {
                        // team1 to next round

                        let toPouleKeyName =
                          p.fase + "-" + p.bracketRound / 2 + "-" + p.bracket;
                        let resultSpot = this.props.resultSpotsAll.find(
                          (rs) =>
                            rs.fromPoule === p.id &&
                            rs.rank === 0 &&
                            rs.belongsToBracket === p.bracket
                        );
                        let toPoule = resultSpot["poule" + p.fase];
                        let toNumInPoule = resultSpot["numInPoule" + p.fase];

                        toUpdateNewTeam["poule" + toPouleKeyName] = toPoule;
                        toUpdateNewTeam["numInPoule" + toPouleKeyName] =
                          toNumInPoule;
                        batch.update(teamsRef.doc(newTeam.id), toUpdateNewTeam);
                        if (numWrites > 450) {
                          batch.commit();
                          batch = db.batch();
                          numWrites = 0;
                        } else {
                          numWrites++;
                        }

                        // set byes in subbrackets
                        const setSubsResults = this.setByesInSubBrackets(
                          p,
                          batch,
                          numWrites
                        );
                        batch = setSubsResults[0];
                        numWrites = setSubsResults[1];
                      }
                    }
                  }
                  if (newTeam2) {
                    if (newTeam2 === "bye") {
                      // set bye
                      let toUpdate = {};
                      toUpdate["status1"] = "bye";
                      batch.update(poulesRef.doc(p.id), toUpdate);
                      if (numWrites > 450) {
                        batch.commit();
                        batch = db.batch();
                        numWrites = 0;
                      } else {
                        numWrites++;
                      }

                      if (currentTeam1) {
                        // team1 to next round
                        let toUpdateCurrentTeam1 = {};

                        let toPouleKeyName =
                          p.fase + "-" + p.bracketRound / 2 + "-" + p.bracket;
                        let resultSpot = this.props.resultSpotsAll.find(
                          (rs) =>
                            rs.fromPoule === p.id &&
                            rs.rank === 0 &&
                            rs.belongsToBracket === p.bracket
                        );
                        let toPoule = resultSpot["poule" + p.fase];
                        let toNumInPoule = resultSpot["numInPoule" + p.fase];

                        toUpdateCurrentTeam1["poule" + toPouleKeyName] =
                          toPoule;
                        toUpdateCurrentTeam1["numInPoule" + toPouleKeyName] =
                          toNumInPoule;
                        batch.update(
                          teamsRef.doc(currentTeam1.id),
                          toUpdateCurrentTeam1
                        );
                        if (numWrites > 450) {
                          batch.commit();
                          batch = db.batch();
                          numWrites = 0;
                        } else {
                          numWrites++;
                        }

                        // set byes in subbrackets
                        const setSubsResults = this.setByesInSubBrackets(
                          p,
                          batch,
                          numWrites
                        );
                        batch = setSubsResults[0];
                        numWrites = setSubsResults[1];
                      }
                    } else if (newTeam2 === "team") {
                      const newTeam = teams.pop();
                      let toUpdateNewTeam = {};

                      toUpdateNewTeam["poule0"] = p.id;
                      toUpdateNewTeam["numInPoule0"] = 1;
                      batch.update(teamsRef.doc(newTeam.id), toUpdateNewTeam);
                      if (numWrites > 450) {
                        batch.commit();
                        batch = db.batch();
                        numWrites = 0;
                      } else {
                        numWrites++;
                      }

                      if (currentTeam1 === "bye" || newTeam1 === "bye") {
                        // team2 to next round

                        let toPouleKeyName =
                          p.fase + "-" + p.bracketRound / 2 + "-" + p.bracket;
                        let resultSpot = this.props.resultSpotsAll.find(
                          (rs) =>
                            rs.fromPoule === p.id &&
                            rs.rank === 0 &&
                            rs.belongsToBracket === p.bracket
                        );
                        let toPoule = resultSpot["poule" + p.fase];
                        let toNumInPoule = resultSpot["numInPoule" + p.fase];

                        toUpdateNewTeam["poule" + toPouleKeyName] = toPoule;
                        toUpdateNewTeam["numInPoule" + toPouleKeyName] =
                          toNumInPoule;
                        batch.update(teamsRef.doc(newTeam.id), toUpdateNewTeam);
                        if (numWrites > 450) {
                          batch.commit();
                          batch = db.batch();
                          numWrites = 0;
                        } else {
                          numWrites++;
                        }

                        // set byes in subbrackets
                        const setSubsResults = this.setByesInSubBrackets(
                          p,
                          batch,
                          numWrites
                        );
                        batch = setSubsResults[0];
                        numWrites = setSubsResults[1];
                      }
                    }
                  }
                });
            }
          } else if (o.pouleSize) {
            let pouleSize = o.pouleSize;
            for (let i = 0; i < Number(pouleSize); i++) {
              let currentTeam = null;
              if (!this.state.overwrite) {
                currentTeam = this.props.teams.find(
                  (t) => t["poule0"] === o.id && t["numInPoule0"] === i
                );
              }
              let newTeam =
                bracketSpots < teams.length && !currentTeam
                  ? teams.pop()
                  : undefined;
              if (newTeam) {
                let toUpdate = {};
                toUpdate["poule0"] = o.id;
                toUpdate["numInPoule0"] = i;
                batch.update(teamsRef.doc(newTeam.id), toUpdate);
                if (numWrites > 450) {
                  batch.commit();
                  batch = db.batch();
                  numWrites = 0;
                } else {
                  numWrites++;
                }
              }
            }
          }
        });

        if (this.props.tournament.ia) {
          batch.set(db.collection("cacheUpdatesApp").doc(), {
            tournamentId: this.props.tournament[".key"],
            status: "pending",
            timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
          });
        }

        batch.commit();
      });
  };

  setByesInSubBrackets = (p, batch, numWrites) => {
    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    const poulesRef = tournamentRef.collection("poules");
    let byesSetInSubBrackets = {};

    // check for subbracket and set bye in subbracket
    let resultSpotLoser = this.props.resultSpotsAll.find(
      (rs) =>
        rs.fromPoule === p.id &&
        rs.rank === 1 &&
        rs.belongsToBracket === p.bracket
    );
    while (resultSpotLoser) {
      let toPouleLoser = resultSpotLoser["poule" + p.fase];
      let loserPouleSubBracket = this.props.poulesByKey[toPouleLoser] || {};
      let toNumInPouleLoser = resultSpotLoser["numInPoule" + p.fase];
      if (toPouleLoser) {
        let pouleRefLoser = poulesRef.doc(toPouleLoser);
        let toUpdateLoser = {};
        toUpdateLoser["status" + toNumInPouleLoser] = "bye";
        if (byesSetInSubBrackets[toPouleLoser] === undefined) {
          byesSetInSubBrackets[toPouleLoser] = {};
        }
        byesSetInSubBrackets[toPouleLoser][toNumInPouleLoser] = true;
        batch.update(pouleRefLoser, toUpdateLoser);
        if (numWrites > 450) {
          batch.commit();
          batch = db.batch();
          numWrites = 0;
        } else {
          numWrites++;
        }
        if (
          (byesSetInSubBrackets[toPouleLoser] || {})[
            toNumInPouleLoser === 0 ? 1 : 0
          ]
        ) {
          let resultSpotWinnerSubBracket = this.props.resultSpotsAll.find(
            (rs) =>
              rs.fromPoule === toPouleLoser &&
              rs.rank === 0 &&
              rs.belongsToBracket === loserPouleSubBracket.bracket
          );
          if (resultSpotWinnerSubBracket) {
            if (resultSpotWinnerSubBracket["poule" + p.fase]) {
              let pouleRefWinnerSubBracket = poulesRef.doc(
                resultSpotWinnerSubBracket["poule" + p.fase]
              );
              let toUpdateWinnerSubBracket = {};
              toUpdateWinnerSubBracket[
                "status" + resultSpotWinnerSubBracket["numInPoule" + p.fase]
              ] = "bye";
              if (
                byesSetInSubBrackets[
                  resultSpotWinnerSubBracket["poule" + p.fase]
                ] === undefined
              ) {
                byesSetInSubBrackets[
                  resultSpotWinnerSubBracket["poule" + p.fase]
                ] = {};
              }
              byesSetInSubBrackets[
                resultSpotWinnerSubBracket["poule" + p.fase]
              ][resultSpotWinnerSubBracket["numInPoule" + p.fase]] = true;
              batch.update(pouleRefWinnerSubBracket, toUpdateWinnerSubBracket);
              if (numWrites > 450) {
                batch.commit();
                batch = db.batch();
                numWrites = 0;
              } else {
                numWrites++;
              }
            }
          }
        }

        resultSpotLoser = this.props.resultSpotsAll.find(
          (rs) =>
            rs.fromPoule === toPouleLoser &&
            rs.rank === 1 &&
            rs.belongsToBracket === loserPouleSubBracket.bracket
        );
      } else {
        // break while loop
        resultSpotLoser = undefined;
      }
    }
    return [batch, numWrites];
  };

  render() {
    let teams = this.props.teams;
    if (!this.state.overwrite) {
      teams = teams.filter((t) => !t.poule0);
    }
    let numTeams = teams.length;
    let numPresent = 0;
    // let numSpots = 0;
    let bracketSpots = 0;
    let showPresentCheckbox = false;
    let disabled = false;
    teams.forEach((t) => {
      if (t.present) {
        showPresentCheckbox = true;
        numPresent++;
      }
    });
    this.props.structureObjects.forEach((o) => {
      // if (o.pouleSize) {
      //   numSpots += Number(o.pouleSize);
      // } else
      if (o.size) {
        if (this.state.overwrite) {
          // numSpots += Number(o.size);
          bracketSpots += Number(o.size);
        } else {
          let poules = this.props.poules.filter(
            (p) => p.bracket === o.id && p.bracketRound === o.size
          );
          poules.forEach((p) => {
            let spotsBracketMatch = 0;
            const team1 = this.props.teams.find(
              (t) => t["poule0"] === p.id && t["numInPoule0"] === 0
            );
            const team2 = this.props.teams.find(
              (t) => t["poule0"] === p.id && t["numInPoule0"] === 1
            );
            if (!team1 && !team2) {
              spotsBracketMatch += 2;
            } else if (
              (p.status0 === "bye" && p.status1 !== "bye" && !team2) ||
              (p.status1 === "bye" && p.status0 !== "bye" && !team1)
            ) {
              spotsBracketMatch += 2;
            }
            bracketSpots += spotsBracketMatch;
          });
        }
      }
    });

    if (bracketSpots > 0) {
      if (this.state.onlyPresent && showPresentCheckbox) {
        disabled = numPresent < bracketSpots / 2;
      } else {
        disabled = numTeams < bracketSpots / 2;
      }
    }
    // console.log(numTeams, numSpots, bracketSpots, disabled);
    return (
      <div>
        {true && (
          <Tooltip title={languages.structure.draw} placement="top">
            <IconButton
              aria-label="Change"
              onClick={this.toggleDialog}
              style={{ height: 20, width: 20 }}
            >
              <ShuffleIcon
                style={{ height: 20, width: 20, position: "absolute", top: 2 }}
              />
            </IconButton>
          </Tooltip>
        )}
        <Dialog
          open={this.state.open}
          onClose={this.toggleDialog}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {languages.structure.draw}
          </DialogTitle>
          <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText>
              {languages.formatString(
                languages.structure.drawText,
                this.props.tournament.individualPlayers
                  ? languages.teams.playersLow
                  : languages.tournament.teamsLow
              )}
            </DialogContentText>

            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.overwrite}
                  onChange={this.handleOverwriteCheck}
                  color="primary"
                />
              }
              label={languages.structure.drawTextOverwrite}
            />

            {showPresentCheckbox && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.onlyPresent}
                    onChange={this.handleCheck}
                    color="primary"
                  />
                }
                label={languages.formatString(
                  this.props.tournament.requireCheckIn
                    ? languages.structure.onlyCheckedIn
                    : languages.structure.onlyPresent,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )}
              />
            )}
            {this.props.tournament.uid === "UiIJajZgHLPImDX1VIBmezMtUtU2" && (
              <FormControl style={{ width: "100%" }}>
                <InputLabel style={{ width: "100%" }} htmlFor="sortDraw">
                  {languages.teams.sort}
                </InputLabel>
                <Select
                  style={{ maxWidth: "100%" }}
                  value={this.state.sort}
                  onChange={this.handleSortChange}
                  inputProps={{
                    name: "sortDraw",
                    id: "sortDraw",
                  }}
                >
                  <MenuItem value="random">
                    {languages.structure.random}
                  </MenuItem>
                  {/* {Object.keys(scoreCalculationTypes).map((key) => {
                  let item = scoreCalculationTypes[key];
                  return (
                    <MenuItem key={key} value={Number(key)}>
                      {item}
                    </MenuItem>
                  );
                })} */}
                  {Object.keys(this.props.tournament.questions || {})
                    .filter(
                      (key) =>
                        this.props.tournament.questions[key].perSignup !== true
                    )
                    .sort((a, b) => {
                      const qA = this.props.tournament.questions[a];
                      const qB = this.props.tournament.questions[b];
                      if (qA.num > qB.num) {
                        return 1;
                      } else if (qA.num < qB.num) {
                        return -1;
                      } else {
                        return 0;
                      }
                    })
                    .map((key) => {
                      let question = this.props.tournament.questions[key];
                      return (
                        <MenuItem key={key} value={"question" + key}>
                          {question.name}
                        </MenuItem>
                      );
                    })}
                  {Object.keys(this.props.tournament.questions || {})
                    .filter(
                      (key) =>
                        this.props.tournament.questions[key].perSignup === true
                    )
                    .sort((a, b) => {
                      const qA = this.props.tournament.questions[a];
                      const qB = this.props.tournament.questions[b];
                      if (qA.num > qB.num) {
                        return 1;
                      } else if (qA.num < qB.num) {
                        return -1;
                      } else {
                        return 0;
                      }
                    })
                    .map((key) => {
                      let question = this.props.tournament.questions[key];
                      return (
                        <MenuItem key={key} value={"question" + key}>
                          {question.name}
                        </MenuItem>
                      );
                    })}
                  {Object.keys(this.props.tournament.infoFields || {}).map(
                    (key) => {
                      let extraField = this.props.tournament.infoFields[key];
                      return (
                        <MenuItem key={key} value={"infoField" + key}>
                          {extraField.name}
                        </MenuItem>
                      );
                    }
                  )}
                </Select>
                {/* <FormHelperText>
                {languages.formatString(
                  languages.structure.sortDraw,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )}
              </FormHelperText> */}
              </FormControl>
            )}
            {disabled && (
              <DialogContentText style={{ color: "red" }}>
                {languages.formatString(
                  languages.structure.drawErrorMessage,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )}
              </DialogContentText>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.handleSubmit}
              variant="contained"
              color="primary"
              type="submit"
              disabled={disabled}
            >
              {languages.structure.startDraw}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default DivideTeamsContainer;
